import React, { createContext, useContext, ReactNode, useEffect } from 'react';
import { RootStore } from './RootStore';

/**
 * StoreContext - React Context for MobX RootStore
 * Provides store access to all components via useStore hook
 */

// Create RootStore instance (singleton pattern)
const rootStore = new RootStore();

// Create React Context
const StoreContext = createContext<RootStore>(rootStore);

/**
 * StoreProvider - Context Provider component
 * Wrap App.tsx with this provider to enable store access
 * Initializes UserStore on mount
 */
export const StoreProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  useEffect(() => {
    // Initialize UserStore when the app starts
    rootStore.userStore.fetchCurrentUser();
  }, []);

  return (
    <StoreContext.Provider value={rootStore}>
      {children}
    </StoreContext.Provider>
  );
};

/**
 * useStore - Hook to access RootStore from components
 * Usage: const { documentStore, uiStore } = useStore();
 */
export const useStore = (): RootStore => {
  const store = useContext(StoreContext);
  if (!store) {
    throw new Error('useStore must be used within StoreProvider');
  }
  return store;
};
